import { Action } from 'redux';
import { put, select } from 'redux-saga/effects';

import { PaymentTypes } from 'models/Payment';
import { PaymentActionTypes, PaymentActions } from '../';
import { ACTION_CREATOR_NAME, userHelper, errorToBasketErrorModel } from 'helpers';
import { AppState, ErrorAction } from 'store';
import { api } from 'repositories/api';
import { initializePaymentCalculatorSaga } from './initializePaymentCalculator';
import { BasketSagaReturnType, callBasketSaga } from 'store/sagaHelpers';

export interface ChangePaymentTypeAction extends Action<PaymentActionTypes.CHANGE_PAYMENT_TYPE> {
    paymentType: PaymentTypes;
}

export interface ChangePaymentTypeActionStart extends Action<PaymentActionTypes.CHANGE_PAYMENT_TYPE_START> {
    paymentType: PaymentTypes;
}

export interface ChangePaymentTypeActionSuccess extends Action<PaymentActionTypes.CHANGE_PAYMENT_TYPE_SUCCESS> {
}

export interface ChangePaymentTypeActionError extends ErrorAction<PaymentActionTypes.CHANGE_PAYMENT_TYPE_ERROR> {
}

export const changePaymentType: (paymentType: PaymentTypes) => ChangePaymentTypeAction = (paymentType: PaymentTypes) => ({
    type: PaymentActionTypes.CHANGE_PAYMENT_TYPE,
    paymentType
});
changePaymentType[ACTION_CREATOR_NAME] = 'changePaymentType';

export type ChangePaymentTypeFunc = (...args: Parameters<typeof changePaymentType>) => void;

export function* changePaymentTypeSaga({ paymentType }: ChangePaymentTypeAction): BasketSagaReturnType {
    yield put<PaymentActions>({
        type: PaymentActionTypes.CHANGE_PAYMENT_TYPE_START,
        paymentType
    });

    try {
        let state: AppState = yield select();

        let paymentDetails = {
            ...state.paymentState.paymentDetails,
            paymentType: state.paymentState.paymentDetails.paymentType
        };

        let sessionId = userHelper.getSessionId();
        let username = userHelper.getCurrentUserName();

        yield api.hybris.savePaymentDetails(username, sessionId!, paymentDetails);

        yield callBasketSaga(initializePaymentCalculatorSaga);

        yield put<PaymentActions>({
            type: PaymentActionTypes.CHANGE_PAYMENT_TYPE_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<PaymentActions>({
            type: PaymentActionTypes.CHANGE_PAYMENT_TYPE_ERROR,
            error: errorToBasketErrorModel(error, 'changePaymentTypeSaga')
        });

        return false;
    }
}